import { opentypeFeatureCSS } from '../../tn.common/functions';

export function opentypeFeatureCSSFilter() {
    return (input: string): string => opentypeFeatureCSS(input);
}
